<template>
  <div ref="root" class="sip_app" :class="{sip_app_isie: $isIE}">
    <div class="wpAnalitycs" />
    <SipSection col="6" center className="sip_header" >
      <div class="sip_logo">
        <img :src="`${$server}logo.svg`" />
      </div>
      <SipCol className="sip_title" text="
        Вдох глубокий, руки шире
      "/>
      <SipCol className="sip_subtitle" text="
        Как начать тренироваться дома
      "/>
      <SipCol text="
        Домашние тренировки во время карантина обрели невероятную популярность: оказалось, что поддерживать себя в форме вполне можно и без абонемента в спортзал. Вместе с экспертами из МГПУ рассказываем, как организовать процесс, если вы хотите заниматься дома, экономя время и деньги
      "/>
    </SipSection>





    <!-- Часть 1 -->
    <div class="wpAnalitycs" />

    <SipSection col="11" center className="sip_section_video">
      <video
        :src="`${$server}video/1.mp4`"
        @canplay="videoCanPlay"
        autoplay loop muted playsinline preload="metadata"
        class="sip_video"
      />
      <div class="sip_video_mask sip_vm1" :style="`background-image: url('${$server}mask_horiz.png')`" />
      <div class="sip_video_mask sip_vm2" :style="`background-image: url('${$server}mask_horiz.png')`" />
      <div class="sip_video_mask sip_vm3" :style="`background-image: url('${$server}mask_vert.png')`" />
      <div class="sip_video_mask sip_vm4" :style="`background-image: url('${$server}mask_vert.png')`" />
    </SipSection>

    <SipSection col="6" center  className="sip_step_header">
      <SipCol className="sip_step_num" text="
        Шаг 1.
      "/>
      <SipCol className="sip_step_title" text="
        Определите цель
      "/>
      <SipCol text="
        Как и в любом деле, в спорте важно расставить приоритеты. Подумайте, чего вы хотите достичь, и сделайте акцент на одном-двух подходящих видах активности. Скорректируйте программу, когда ваша цель изменится
      "/>
    </SipSection>

    <AppSlider @clicked="onChangeSlider" />

    <SipSection center flex className="sip_vrez_w">
      <div class="sip_vrez">
        <div class="sip_vrez_icon">
          <svg width="33" height="118" viewBox="0 0 33 118" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.515625 0H32.4844L27.1562 76.1667H5.84375L0.515625 0ZM16.5 118C11.8021 118 7.84896 116.556 4.64062 113.667C1.54687 110.667 0 107.056 0 102.833C0 98.6111 1.54687 95.1111 4.64062 92.3333C7.73437 89.4444 11.6875 88 16.5 88C21.3125 88 25.2656 89.4444 28.3594 92.3333C31.4531 95.1111 33 98.6111 33 102.833C33 107.056 31.3958 110.667 28.1875 113.667C25.0937 116.556 21.1979 118 16.5 118Z" fill="#FE5959"/>
          </svg>
        </div>
        <SipCol className="sip_vrez_text" text="
          В тренировках важен эмоциональный настрой. Стоит прислушиваться к потребностям организма в настоящий момент и радовать его наиболее подходящим видом физической активности
        "/>
      </div>
      <div class="sip_vrez_bg" />
    </SipSection>


    <!-- Часть 2 -->
    <div class="wpAnalitycs" />

    <div class="sip_divide_s" />
    <SipSection col="11" center  className="sip_section_video" >
      <video
        :src="`${$server}video/2.mp4`"
        @canplay="videoCanPlay"
        autoplay loop muted playsinline preload="metadata"
        class="sip_video"
      />
      <div class="sip_video_mask sip_vm1" :style="`background-image: url('${$server}mask_horiz.png')`" />
      <div class="sip_video_mask sip_vm2" :style="`background-image: url('${$server}mask_horiz.png')`" />
      <div class="sip_video_mask sip_vm3" :style="`background-image: url('${$server}mask_vert.png')`" />
      <div class="sip_video_mask sip_vm4" :style="`background-image: url('${$server}mask_vert.png')`" />
    </SipSection>

    <SipSection col="6" center  className="sip_step_header">
      <SipCol className="sip_step_num" text="
        Шаг 2.
      "/>
      <SipCol className="sip_step_title" text="
        Продумайте режим
      "/>
      <SipCol text="
        Регулярность — залог успеха. Лучше заниматься по полчаса три раза в неделю, чем проводить одну ударную тренировку в месяц. Честно признайтесь себе, сколько времени вы готовы выделить на спорт, сделайте расписание и строго следуйте ему
      "/>
    </SipSection>


    <SipSection col="6" center  className="sip_regimen">
      <div class="sip_grid sip_horiz_center">
        <div class="sip_regimen_image">
          <img :src="`${$server}ch2-1.svg`" />
        </div>
        <div class="sip_regimen_text">
          <div class="sip_regimen_title">частота:</div>
          <div class="sip_regimen_body"><span>3-6</span> раз в неделю</div>
        </div>
      </div>
    </SipSection>

    <SipSection col="6" center  className="sip_regimen">
      <div class="sip_grid sip_horiz_center">
        <div class="sip_regimen_image">
          <img :src="`${$server}ch2-2.svg`" />
        </div>
        <div class="sip_regimen_text">
          <div class="sip_regimen_title">продолжительность:</div>
          <div class="sip_regimen_body"><span>45–90</span> минут</div>
        </div>
      </div>
    </SipSection>

    <SipSection col="6" center  className="sip_regimen">
      <div class="sip_grid sip_horiz_center">
        <div class="sip_regimen_image">
          <img :src="`${$server}ch2-3.svg`" />
        </div>
        <div class="sip_regimen_text">
          <div class="sip_regimen_title">время:</div>
          <div class="sip_regimen_body">во второй половине дня, не раньше, чем через два часа после еды и не позже, чем за час до еды или сна</div>
        </div>
      </div>
    </SipSection>

    <SipSection col="6" center  className="sip_regimen">
      <div class="sip_grid sip_horiz_center">
        <div class="sip_regimen_image">
          <img :src="`${$server}ch2-4.svg`" />
        </div>
        <div class="sip_regimen_text">
          <div class="sip_regimen_title">структура:</div>
          <div class="sip_regimen_body">
            разминка (7–15 мин.),<br>
            основная часть (30–60 мин.),<br>
            заключительная часть (7–15 мин.)
          </div>
        </div>
      </div>
    </SipSection>

<!--
    <SipSection className="sip_link">
      <div>
        Сохраните и распечатайте шаблон дневника тренировок
      </div>
    </SipSection>
-->

    <SipSection center flex className="sip_vrez_w">
      <div class="sip_vrez">
        <div class="sip_vrez_icon">
          <svg width="33" height="118" viewBox="0 0 33 118" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.515625 0H32.4844L27.1562 76.1667H5.84375L0.515625 0ZM16.5 118C11.8021 118 7.84896 116.556 4.64062 113.667C1.54687 110.667 0 107.056 0 102.833C0 98.6111 1.54687 95.1111 4.64062 92.3333C7.73437 89.4444 11.6875 88 16.5 88C21.3125 88 25.2656 89.4444 28.3594 92.3333C31.4531 95.1111 33 98.6111 33 102.833C33 107.056 31.3958 110.667 28.1875 113.667C25.0937 116.556 21.1979 118 16.5 118Z" fill="#FE5959"/>
          </svg>
        </div>
        <SipCol className="sip_vrez_text" text="
          Не проводите интенсивные тренировки утром натощак, занимайтесь в хорошо проветриваемом помещении и старайтесь делать это в одни и те же дни недели примерно в одно время
        "/>
      </div>
      <div class="sip_vrez_bg" />
    </SipSection>



    <!-- Часть 3 -->
    <div class="wpAnalitycs" />

    <div class="sip_divide_s" />
    <SipSection col="11" center  className="sip_section_video" >

      <video
        :src="`${$server}video/3.mp4`"
        @canplay="videoCanPlay"
        autoplay loop muted playsinline preload="metadata"
        class="sip_video"
      />
      <div class="sip_video_mask sip_vm1" :style="`background-image: url('${$server}mask_horiz.png')`" />
      <div class="sip_video_mask sip_vm2" :style="`background-image: url('${$server}mask_horiz.png')`" />
      <div class="sip_video_mask sip_vm3" :style="`background-image: url('${$server}mask_vert.png')`" />
      <div class="sip_video_mask sip_vm4" :style="`background-image: url('${$server}mask_vert.png')`" />
    </SipSection>

    <SipSection col="6" center  className="sip_step_header">
      <SipCol className="sip_step_num" text="
        Шаг 3.
      "/>
      <SipCol className="sip_step_title" text="
        Освойте базу
      "/>
      <SipCol text="
        Не стоит сразу покупать комплект спортивных снарядов: начните с упражнений с собственным весом и отточите правильную технику
      "/>
    </SipSection>


    <AppSliderBig  @clicked="onChangeSliderBig" />

    <SipSection center flex className="sip_vrez_w">
      <div class="sip_vrez">
        <div class="sip_vrez_icon">
          <svg width="33" height="118" viewBox="0 0 33 118" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.515625 0H32.4844L27.1562 76.1667H5.84375L0.515625 0ZM16.5 118C11.8021 118 7.84896 116.556 4.64062 113.667C1.54687 110.667 0 107.056 0 102.833C0 98.6111 1.54687 95.1111 4.64062 92.3333C7.73437 89.4444 11.6875 88 16.5 88C21.3125 88 25.2656 89.4444 28.3594 92.3333C31.4531 95.1111 33 98.6111 33 102.833C33 107.056 31.3958 110.667 28.1875 113.667C25.0937 116.556 21.1979 118 16.5 118Z" fill="#FE5959"/>
          </svg>
        </div>
        <SipCol className="sip_vrez_text" text="
          Подготовьте свободное пространство для занятий, обеспечьте себе хорошее, желательно естественное освещение и уберите подальше травмоопасные предметы
        "/>
      </div>
      <div class="sip_vrez_bg" />
    </SipSection>



    <!-- Часть 4 -->
    <div class="wpAnalitycs" />

    <div class="sip_divide_s" />
    <SipSection col="11" center  className="sip_section_video">

      <video
        :src="`${$server}video/4.mp4`"
        @canplay="videoCanPlay"
        autoplay loop muted playsinline preload="metadata"
        class="sip_video"
      />
      <div class="sip_video_mask sip_vm1" :style="`background-image: url('${$server}mask_horiz.png')`" />
      <div class="sip_video_mask sip_vm2" :style="`background-image: url('${$server}mask_horiz.png')`" />
      <div class="sip_video_mask sip_vm3" :style="`background-image: url('${$server}mask_vert.png')`" />
      <div class="sip_video_mask sip_vm4" :style="`background-image: url('${$server}mask_vert.png')`" />
    </SipSection>

    <SipSection col="6" center  className="sip_step_header">
      <SipCol className="sip_step_num" text="
        Шаг 4.
      "/>
      <SipCol className="sip_step_title" text="
        Учтите свои особенности
      "/>
      <SipCol text="
        Помните, что спорт должен приносить пользу, а не вред. Если у вас есть ограничения по здоровью, будьте внимательны при выборе упражнений
      "/>
    </SipSection>


    <SipSection center  className="sip_regimen sip_regimen_ch4 sip_w_690 sip_mb_50">
      <div class="sip_grid sip_horiz_center">
        <div class="sip_regimen_image">
          <img :src="`${$server}ch4-1.svg`" />
        </div>
        <div class="sip_regimen_text">
          <div class="sip_regimen_subtitle">Заболевания:</div>
          <div class="sip_regimen_body2">СЕРДЕЧНО-СОСУДИСТЫЕ, ДЫХАТЕЛЬНЫЕ, САХАРНЫЙ ДИАБЕТ</div>
          <div class="sip_regimen_subtitle">Противопоказано:</div>
          <div class="sip_regimen_body2">Упражнения высокой интенсивности, резкие движения, задержка дыхания на занятиях</div>
          <div class="sip_regimen_subtitle">Ограничено:</div>
          <div class="sip_regimen_body2">Тренировки умеренной интенсивности, ударные нагрузки, статические напряжения</div>
        </div>
      </div>
    </SipSection>

    <SipSection center  className="sip_regimen sip_regimen_ch4 sip_w_690 sip_mb_50">
      <div class="sip_grid sip_horiz_center">
        <div class="sip_regimen_image">
          <img :src="`${$server}ch4-2.svg`" />
        </div>
        <div class="sip_regimen_text">
          <div class="sip_regimen_subtitle">Заболевания:</div>
          <div class="sip_regimen_body2">НАРУШЕНИЯ ЗРЕНИЯ</div>
          <div class="sip_regimen_subtitle">Противопоказано:</div>
          <div class="sip_regimen_body2">Наклоны, прыжки, упражнения высокой интенсивности</div>
          <div class="sip_regimen_subtitle">Ограничено:</div>
          <div class="sip_regimen_body2">Упражнения с отягощениями, статические напряжения</div>
        </div>
      </div>
    </SipSection>

    <SipSection center  className="sip_regimen sip_regimen_ch4 sip_w_690 sip_mb_50">
      <div class="sip_grid sip_horiz_center">
        <div class="sip_regimen_image">
          <img :src="`${$server}ch4-3.svg`" />
        </div>
        <div class="sip_regimen_text">
          <div class="sip_regimen_subtitle">Заболевания:</div>
          <div class="sip_regimen_body2">ОЖИРЕНИЕ</div>
          <div class="sip_regimen_subtitle">Противопоказано:</div>
          <div class="sip_regimen_body2">Упражнения высокой интенсивности, резкие движения, задержка дыхания на занятиях, тренировки с вертикальным отягощением</div>
        </div>
      </div>
    </SipSection>

<div class="sip_divide_xs" />

    <SipSection center flex className="sip_vrez_w">
      <div class="sip_vrez">
        <div class="sip_vrez_icon">
          <svg width="33" height="118" viewBox="0 0 33 118" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.515625 0H32.4844L27.1562 76.1667H5.84375L0.515625 0ZM16.5 118C11.8021 118 7.84896 116.556 4.64062 113.667C1.54687 110.667 0 107.056 0 102.833C0 98.6111 1.54687 95.1111 4.64062 92.3333C7.73437 89.4444 11.6875 88 16.5 88C21.3125 88 25.2656 89.4444 28.3594 92.3333C31.4531 95.1111 33 98.6111 33 102.833C33 107.056 31.3958 110.667 28.1875 113.667C25.0937 116.556 21.1979 118 16.5 118Z" fill="#FE5959"/>
          </svg>
        </div>
        <SipCol className="sip_vrez_text" text="
          При травмах любой давности и хронических заболеваниях необходима консультация специалиста ЛФК. Он порекомендует оптимальные виды физической активности
        "/>
      </div>
      <div class="sip_vrez_bg" />
    </SipSection>



    <!-- Часть 5 -->
    <div class="wpAnalitycs" />

    <div class="sip_divide_s" />
    <SipSection col="11" center  className="sip_section_video">

      <video
        :src="`${$server}video/5.mp4`"
        @canplay="videoCanPlay"
        autoplay loop muted playsinline preload="metadata"
        class="sip_video"
      />
      <div class="sip_video_mask sip_vm1" :style="`background-image: url('${$server}mask_horiz.png')`" />
      <div class="sip_video_mask sip_vm2" :style="`background-image: url('${$server}mask_horiz.png')`" />
      <div class="sip_video_mask sip_vm3" :style="`background-image: url('${$server}mask_vert.png')`" />
      <div class="sip_video_mask sip_vm4" :style="`background-image: url('${$server}mask_vert.png')`" />
      
    </SipSection>

    <SipSection col="6" center  className="sip_step_header">
      <SipCol className="sip_step_num" text="
        Шаг 5.
      "/>
      <SipCol className="sip_step_title" text="
        Поддерживайте мотивацию
      "/>
      <SipCol text="
        Настанет момент, когда захочется пропустить тренировку: это мозг попытается вас обмануть. Важно научиться замечать такие вещи и&nbsp;обманывать его в&nbsp;ответ одним из&nbsp;проверенных способов&nbsp;&mdash; тело будет благодарно за&nbsp;результат
      "/>
    </SipSection>


    <div class="sip_cards_grid">
    
    <SipSection center  className="sip_card">
      <div>
        <div class="sip_card_image_w">
          <div class="sip_card_image" :style="`background-image: url(${$server}ch5-1.svg)`" />
          <div class="sip_card_image_bg" />
        </div>
        <div class="sip_card_text">
          <div class="sip_card_title">
            ОБЕЩАНИЕ  В СОЦСЕТИ
          </div>
          <AppText class="sip_card_text_body" body="
            Поставьте себе цель и&nbsp;опубликуйте в&nbsp;Сети план её&nbsp;выполнения. Делитесь успехами&nbsp;&mdash; это вдохновит на&nbsp;новые подвиги
          " />
        </div>
      </div>
    </SipSection>

    <SipSection center  className="sip_card">
      <div>
        <div class="sip_card_image_w">
          <div class="sip_card_image" :style="`background-image: url(${$server}ch5-2.svg)`" />
          <div class="sip_card_image_bg" />
        </div>
        <div class="sip_card_text">
          <div class="sip_card_title">
            УЧАСТИЕ В ЧЕЛЛЕНДЖЕ
          </div>
          <AppText class="sip_card_text_body" body="
            Придумайте спортивное испытание и&nbsp;пригласите участвовать в&nbsp;нём ваших родных, друзей или подписчиков в&nbsp;соцсетях
          " />
        </div>
      </div>
    </SipSection>

    <SipSection center  className="sip_card">
      <div>
        <div class="sip_card_image_w">
          <div class="sip_card_image" :style="`background-image: url(${$server}ch5-3.svg)`" />
          <div class="sip_card_image_bg" />
        </div>
        <div class="sip_card_text">
          <div class="sip_card_title">
            СЕМЕЙНЫЕ ТРЕНИРОВКИ
          </div>
          <AppText class="sip_card_text_body" body="
            Подключите домочадцев к&nbsp;регулярным занятиям. С&nbsp;детьми можно попробовать парные упражнения
          " />
        </div>
      </div>
    </SipSection>

    <SipSection center  className="sip_card">
      <div>
        <div class="sip_card_image_w">
          <div class="sip_card_image" :style="`background-image: url(${$server}ch5-4.svg)`" />
          <div class="sip_card_image_bg" />
        </div>
        <div class="sip_card_text">
          <div class="sip_card_title">
            ФИТНЕС-ЛОТО
          </div>
          <AppText class="sip_card_text_body" body="
            Составьте на&nbsp;бумаге лото из&nbsp;ячеек с&nbsp;заданиями. Старайтесь за&nbsp;неделю выполнить и&nbsp;закрасить как можно больше заданий
          " />
        </div>
      </div>
    </SipSection>

    <SipSection center  className="sip_card">
      <div>
        <div class="sip_card_image_w">
          <div class="sip_card_image" :style="`background-image: url(${$server}ch5-5.svg)`" />
          <div class="sip_card_image_bg" />
        </div>
        <div class="sip_card_text">
          <div class="sip_card_title">
            НАГРАДА ЗА ДОСТИЖЕНИЯ
          </div>
          <AppText class="sip_card_text_body" body="
            Делайте себе подарки за&nbsp;успехи. Это может быть красивая спортивная форма или массаж (главное, не&nbsp;десерт!)
          " />
        </div>
      </div>
    </SipSection>

    </div>


    <SipSection className="sip_link">
      <a :href="`${$server}mgpu_tracker.pdf`" :download="`mgpu_tracker.pdf`">
        Сохраните и распечатайте трекер тренировок на 21 день
      </a>

    </SipSection>



    <SipSection center flex className="sip_vrez_w">
      <div class="sip_vrez">
        <div class="sip_vrez_icon">
          <svg width="33" height="118" viewBox="0 0 33 118" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.515625 0H32.4844L27.1562 76.1667H5.84375L0.515625 0ZM16.5 118C11.8021 118 7.84896 116.556 4.64062 113.667C1.54687 110.667 0 107.056 0 102.833C0 98.6111 1.54687 95.1111 4.64062 92.3333C7.73437 89.4444 11.6875 88 16.5 88C21.3125 88 25.2656 89.4444 28.3594 92.3333C31.4531 95.1111 33 98.6111 33 102.833C33 107.056 31.3958 110.667 28.1875 113.667C25.0937 116.556 21.1979 118 16.5 118Z" fill="#FE5959"/>
          </svg>
        </div>
        <SipCol className="sip_vrez_text" text="
          В начале пути важно не нарушать режим тренировок минимум 21 день — именно столько нужно, чтобы занятия вошли в привычку. Дальше будет проще — организм втянется и сам начнёт требовать нагрузки
        "/>
      </div>
      <div class="sip_vrez_bg" />
    </SipSection>


  <div class="wpAnalitycs" />
  <div class="sip_logo">
    <img :src="`${$server}logo.svg`" />
    <br><br>
    <div>
      Источник: 
      Московский городской педагогический университет
    <div>
    </div>
      МИА «Россия сегодня», 2020 год
    </div>
    <br><br>
    <img :src="`${$server}logo2.svg`" />
  </div>


  </div>
</template>

<script>
import SipSection from './components/AppGrid/Section.js'
import SipCol from './components/AppGrid/Column.js'
import SipText from './components/AppGrid/Text.js'
import SipGrid from './components/AppGrid/Grid.js'
import './components/AppGrid/style.styl'
import AppSlider from './components/AppSlider.vue'
// import AppSliderBig from './components/AppSliderBig.vue'
const AppSliderBig = () => import('./components/AppSliderBig.vue')
import AppText from './components/AppText'
import ResizeObserver from 'resize-observer-polyfill'
require('waypoints/lib/noframework.waypoints.min.js')
import { connect, post, event } from './gtm.js'

window.app = {}
window.app.projectName = "mgpufit";
window.app.version = "d";

export default {
  name: 'App',
  data() {
    return {
      wpList: []
    }
  },
  components: {
    SipSection, SipCol, SipText, SipGrid, AppSlider, AppSliderBig, AppText, Waypoint
  },
  mounted () {
    connect(app)
    event('entrance')
    setTimeout(()=>{
      this.setHeight()
    }, 1000)
  },
  methods: {
    // wpAnalitycs(val) {
    //   console.log(1)
    //   event('anchor', {anchor: `anchor-${val}`})
    // },
    onChangeSlider (val) {
      event('inner_link', { link: `slider1-${val}` })
    },
    onChangeSliderBig (val) {
      event('inner_link', { link: `slider2-${val}` })
    },
    videoCanPlay() {

    },
    setHeight () {
      const resizeObserverSlide = new ResizeObserver(entries => {
        console.log('>>> done')
        this.wpAnalitycs()
      })
      resizeObserverSlide.observe(this.$refs.root);
    },
    wpAnalitycs() {
      let list = Array.prototype.slice.call( this.$refs.root.querySelectorAll('.wpAnalitycs') );
      if(this.wpList.length > 0) {
        this.wpList.map(m=>m.destroy())
        this.wpList = []
      }
      list.map((m,i)=>{
        let waypoint = new Waypoint({
          element: m,
          offset: '10%',
          handler: (direction) => {
            if(direction === 'down') {
              event('anchor', {anchor: `anchor-${i}`});
            }
          }
        })
        this.wpList.push(waypoint)
      })
    },
  },
}
</script>

<style lang="stylus" src="./App.styl" />
